import { useEffect, useRef, useState, MouseEvent } from "react";
import { IOption } from "interface";
import i18n from "locales/i18n";
import { langOps } from "util/option";
import { useParams } from "react-router-dom";
import { useMutation } from "@tanstack/react-query";
import { lodInfApi } from "components/api/comm";
import { useAuthContext } from "components/context/authContext";

type IProps = {
  styles?: string;
  height: number;
};

export default function LangChange({ styles = "right-0", height }: IProps) {
  const { lodNo } = useParams();
  const { setLodInf } = useAuthContext();
  const langCd = i18n.language;
  const langRef = useRef<HTMLDivElement>(null);

  const [langOp, setLangOp] = useState(() => {
    const resLangs = langOps.filter((lng) => {
      return lng.code !== langCd;
    });
    const nowLangs = langOps.filter((lng) => {
      return lng.code === langCd;
    });

    return [...nowLangs, ...resLangs];
  });

  //숙소정보 가져오기
  const lodInfMutation = useMutation({
    mutationFn: lodInfApi,
    onSuccess: (res) => {
      if (res) {
        if (res.data) {
          const { lodInfo, defAdltPerCt, defRmCt } = res.data;

          setLodInf({
            ...lodInfo,
            defAdltPerCt,
            defRmCt,
          });
          localStorage.setItem(
            "lodInf",
            JSON.stringify({
              ...lodInfo,
              defAdltPerCt,
              defRmCt,
            })
          );
        }
      }
    },
  });

  const handleLang = (e: MouseEvent<HTMLButtonElement>, lang: IOption) => {
    i18n.changeLanguage(lang.code);
    localStorage.setItem("langCd", lang.code);
    const newlangs = langOps.filter((lng) => {
      return lng.code !== lang.code;
    });
    setLangOp([lang, ...newlangs]);

    if (langRef.current) {
      const classNm = langRef.current.className;
      const classList = langRef.current.classList as DOMTokenList;
      const filterClassNm = Array.from(classList)
        .filter((clss) => {
          return clss !== "visible";
        })
        .join(" ");

      if (classNm.includes("visible")) {
        langRef.current.className = filterClassNm;
        langRef.current.style.height = 28 + "px";
        window.location.reload();

        if (lodNo) {
          // lodInfMutation.mutate({ lodNo });
        }
      }
      if (!classNm.includes("visible")) {
        langRef.current.className = filterClassNm + " " + "visible";
        langRef.current.style.height = height * langOps.length + "px";
      }
    }
  };

  const outSideClick = (e: any) => {
    if (langRef.current && !langRef.current.contains(e.target)) {
      langRef.current.className = "lang-btn" + " " + styles;
      langRef.current.style.height = height + "px";
    }
  };

  useEffect(() => {
    document.addEventListener("click", outSideClick);

    return () => {
      document.removeEventListener("click", outSideClick);
    };
  }, []);
  return (
    <>
      <div className={"lang-btn " + " " + styles} ref={langRef}>
        {langOp.map((lang: IOption, index: number) => {
          return (
            <button
              key={index}
              data-lang-code={lang.code}
              onClick={(e) => handleLang(e, lang)}
              // style={{ minHeight: height }}
            >
              {lang.ko}
            </button>
          );
        })}
      </div>
    </>
  );
}
